var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.screen === 'safe-reporting-incident')?_c('safe-reporting-incident'):_vm._e(),(_vm.screen === 'complaints')?_c('complaints'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }